import {useSelector} from 'react-redux'
import BasicCardDocumentos from '../BasicCardDocumentos'
import InputForm from '../InputFormV2'
import SelectCatalogoV2 from './SelectCatalogoV2'
import SelectDistritoReceptor from './SelectDistritoReceptor'
import CampoFusion from './CampoFusion'
import {State} from '../../../../reducers'
import {ENDPOINTS} from '../../../../api/config'
import {esNormativaV2} from '../../../../utils/normativa.utils'

export const TIPO_DOCUMENTO_NIT = '36'

interface PropiedadesCamposReceptorNotaV2 {
  numDocumento: any
  departamento: any
  municipio: any
  distrito: any
  errorDistrito?: any
  onChangeDistrito: (valor: string) => void
  codigoRetencionMH: any
  errorCodigoRetencionMH?: any
  onChangeCodigoRetencionMH: (valor: string) => void
}

export default function CamposReceptorNotaV2({
  numDocumento,
  departamento,
  municipio,
  distrito,
  errorDistrito,
  onChangeDistrito,
  codigoRetencionMH,
  errorCodigoRetencionMH,
  onChangeCodigoRetencionMH,
}: PropiedadesCamposReceptorNotaV2) {
  const {tipoDocumento, datosEmisor} = useSelector((state: State) => state.catalogos)

  if (!esNormativaV2(datosEmisor)) return null

  const nombreTipoDocumento =
    (tipoDocumento ?? []).find((tipo: any) => tipo?.codigo === TIPO_DOCUMENTO_NIT)?.valor ?? 'NIT'

  return (
    <BasicCardDocumentos title='Datos de la normativa 2.0'>
      <div className='w-layout-hflex h-inputs'>
        <InputForm
          disabled
          required
          name='tipoDocumentoReceptor'
          label='Tipo de documento del receptor'
          type='text'
          value={`${TIPO_DOCUMENTO_NIT} - ${nombreTipoDocumento}`}
          helperText='En la normativa 2.0 la nota identifica al receptor con tipo y número de documento.'
          onChange={() => {}}
        />
        <InputForm
          disabled
          required
          name='numDocumentoReceptor'
          label='Número de documento del receptor'
          type='text'
          value={`${numDocumento ?? ''}`}
          onChange={() => {}}
        />
      </div>
      <SelectDistritoReceptor
        departamento={departamento}
        municipio={municipio}
        distrito={distrito}
        error={errorDistrito}
        onChange={onChangeDistrito}
      />
      <div className='w-layout-hflex h-inputs'>
        <div className='label-input'>
          <SelectCatalogoV2
            endpoint={ENDPOINTS.GET_RETENCION_IVA_MH}
            nombre='codigoRetencionMH'
            etiqueta='Código de retención de IVA'
            marcador='Código de retención'
            valor={codigoRetencionMH}
            error={errorCodigoRetencionMH}
            ayuda='Selecciónelo solo si la nota lleva retención de IVA. Si lo deja vacío, se envía sin código.'
            onChange={onChangeCodigoRetencionMH}
          />
        </div>
        <div className='label-input'>
          <CampoFusion />
        </div>
      </div>
    </BasicCardDocumentos>
  )
}
